import { useEffect, useState } from 'react';
import { ArrowUpRight, Menu, X } from 'lucide-react';
import { LOGO_URL, NAV_LINKS } from './dionData';

export const DionNav = ({ onNavigate, onConsult }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  const go = (id) => { setOpen(false); onNavigate(id); };

  return (
    <>
      <header
        data-testid="dion-nav"
        className="fixed top-0 inset-x-0 z-[110] transition-colors duration-500"
        style={{
          background: scrolled ? 'rgba(11,15,22,0.72)' : 'transparent',
          backdropFilter: scrolled ? 'blur(16px)' : 'none',
          borderBottom: scrolled ? '1px solid rgba(255,255,255,0.08)' : '1px solid transparent',
        }}
      >
        <div className="mx-auto flex h-[72px] max-w-[1600px] items-center justify-between gap-6 px-5 sm:px-8">
          <button onClick={() => go('dion-top')} className="flex items-center gap-4" data-testid="dion-nav-logo" aria-label="Dion Hair Clinic — nach oben">
            <img src={LOGO_URL} alt="Dion Hair Clinic" width="58" height="34" className="dh-logo h-8 w-auto" />
            <span className="hidden text-[13px] font-medium tracking-[0.18em] text-white/90 sm:inline">DION HAIR CLINIC</span>
          </button>

          <nav className="hidden items-center gap-8 lg:flex" aria-label="Hauptnavigation">
            {NAV_LINKS.map((l) => (
              <button
                key={l.id}
                onClick={() => go(l.id)}
                data-testid={`dion-nav-${l.id}`}
                className="group relative py-2 text-[12px] font-medium tracking-[0.14em] text-white/70 transition-colors hover:text-white"
              >
                {l.label}
                <span className="absolute bottom-1 left-0 h-px w-full origin-left scale-x-0 bg-[#5b8da8] transition-transform duration-300 group-hover:scale-x-100" />
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button onClick={onConsult} data-testid="dion-nav-cta-button" className="dh-btn dh-btn-solid hidden !px-5 !py-3 !text-[11px] sm:inline-flex">
              Beratung vereinbaren <ArrowUpRight size={15} />
            </button>
            <button onClick={() => setOpen(true)} data-testid="dion-menu-open" aria-label="Menü öffnen" className="grid h-11 w-11 place-items-center border border-white/15 text-white lg:hidden">
              <Menu size={20} />
            </button>
          </div>
        </div>
      </header>

      {open && (
        <>
          <div className="fixed inset-0 z-[125] bg-black/60 backdrop-blur-sm" onClick={() => setOpen(false)} data-testid="dion-menu-overlay" />
          <div className="dion-menu" role="dialog" aria-modal="true" data-testid="dion-mobile-menu">
            <div className="mb-10 flex items-center justify-between">
              <span className="text-[13px] font-medium tracking-[0.18em]">DION HAIR CLINIC</span>
              <button onClick={() => setOpen(false)} aria-label="Menü schließen" data-testid="dion-menu-close" className="grid h-11 w-11 place-items-center border border-white/15">
                <X size={20} />
              </button>
            </div>
            <nav aria-label="Mobile Navigation">
              {NAV_LINKS.map((l) => (
                <a key={l.id} onClick={() => go(l.id)} data-testid={`dion-mobile-${l.id}`} className="cursor-pointer text-white/90">
                  {l.label} <ArrowUpRight size={20} className="text-[#5b8da8]" />
                </a>
              ))}
            </nav>
            <button onClick={() => { setOpen(false); onConsult(); }} data-testid="dion-mobile-cta" className="dh-btn dh-btn-solid mt-8 w-full justify-between">
              Beratung vereinbaren <ArrowUpRight size={16} />
            </button>
          </div>
        </>
      )}
    </>
  );
};
